var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiUserPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_852_9841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99902 12.25V11.0833C9.99902 10.4645 9.75319 9.871 9.31561 9.43342C8.87802 8.99583 8.28453 8.75 7.66569 8.75H3.58236C2.96352 8.75 2.37003 8.99583 1.93244 9.43342C1.49486 9.871 1.24902 10.4645 1.24902 11.0833V12.25",
    stroke: "#646DF3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.62435 6.41667C6.91301 6.41667 7.95768 5.372 7.95768 4.08333C7.95768 2.79467 6.91301 1.75 5.62435 1.75C4.33568 1.75 3.29102 2.79467 3.29102 4.08333C3.29102 5.372 4.33568 6.41667 5.62435 6.41667Z",
    stroke: "#646DF3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.333 4.66602V8.16602",
    stroke: "#646DF3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.083 6.41602H10.583",
    stroke: "#646DF3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_852_9841"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.666016)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiUserPlus);
export default __webpack_public_path__ + "static/media/FiUserPlus.c8d9cf27055a620a20e7ac5b8b14c86d.svg";
export { ForwardRef as ReactComponent };